import React from 'react'

const Switcher = ({ omni, toggleSignIn, children }) =>
  <div className="mb-3">
    <div className="d-grid gap-2">
      <div dangerouslySetInnerHTML={{ __html: omni }} />
      <div className="d-grid">
        <button type="button" className="btn btn-light" onClick={toggleSignIn}>
          {children}
        </button>
      </div>
    </div>

    <div className="border-top text-center mt-4 mb-n3">
      <small
        className="d-inline-block bg-white text-body-secondary px-2"
        style={{ translate: '0 -0.8125rem' }}
      >OR</small>
    </div>
  </div>

export default Switcher
